<template>
	<section>
		<p class="f-20 f-m-14 margin-0"><strong>{{ title }}</strong></p>
		<p class="f-14 f-m-12 c-grey margin-0">Silahkan lengkapi data {{note}} dibawah ini</p>
		<hr>
	</section>
</template>

<script>
export default {
	name: 'HeaderForm',
	props: ['title', 'note']
}
</script>